import SummarizeMoreButton from './SummarizeMoreButton';

export default SummarizeMoreButton;
